class ZcyGXFullTextSearch {

}

module.exports = ZcyGXFullTextSearch;
